export default "__VITE_ASSET__ChoNiKIY__"